import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import './StoreResults.scss'
import Helmet from 'react-helmet'
import classnames from 'classnames'
import { doTrack } from '../../helpers/TaggingSerializer'

import StoreResult from '../../components/Results/StoreResult/StoreResult'
import AZStoreBtn from '../../components/AZStore/AZStore'

class Results extends PureComponent {
  componentDidMount () {
    if (global.window) {
      doTrack('ar:storelocator:storesList:')
    }
  }
  render () {
    const listMapViewClass = classnames('sc-results-list list-unstyled', { 'sc-results-list-active': this.props.activeStore })
    const metaData = {
      meta: [{
        name: 'robots',
        content: `noindex, nofollow`
      }]
    }
    return (
      <div className='sc-results'>
        <script dangerouslySetInnerHTML={{ __html: `window.digitalData.page.pageInfo.pageName = 'ar:storelocator:storesList:'` }} />
        <Helmet {...metaData} />
        <div className='sc-results-list-wrap' id='sc-results-list'>
          <ol className={listMapViewClass}>
            {
              this.props.stores.map((store, index) =>
                <StoreResult {...store}
                  active={this.props.activeStore === store.id}
                  toggleActive={this.props.toggleActive}
                  key={index}
                  order={index} />
              )
            }
          </ol>
          <AZStoreBtn showAZList={this.props.showAZList} />
        </div>
      </div>
    )
  }
}

Results.propTypes = {
  stores: PropTypes.array,
  activeStore: PropTypes.string,
  toggleActive: PropTypes.func,
  showAZList: PropTypes.func
}

export default Results



// WEBPACK FOOTER //
// ./src/containers/StoreResults/StoreResults.jsx